/* Amyan Art draft overrides, script 3 (10/2026). Loaded sitewide, deferred, from sections/footer-group.json. */
(function () {
  // Sharp shimmer for the three shimmering labels.
  //
  // The first shimmer painted a moving colour gradient through the letters (background-clip: text).
  // On a high-resolution screen the browser draws that kind of text as a low-resolution picture and
  // stretches it, so the letters looked very blurry. Here each letter becomes its own piece of normal
  // text, and a highlight colour runs along the letters one after another. Normal text is always drawn
  // sharp. Each letter only gets its position number (--i); colours and ALL timing (how fast the
  // highlight travels, how often it repeats) are set in assets/amyan-overrides-d.css.
  var SELECTORS = [
    '[class*="__header_announcements_"] .announcement-bar__text',
    '.amyan-fs .amyan-fs__title',
    '.cc-section .cc-heading'
  ];

  function splitIntoLetters(el) {
    if (el.dataset.amyanShine) return;
    var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (!text) return;
    el.dataset.amyanShine = '1';
    // Screen readers get the sentence once, not letter by letter.
    el.setAttribute('aria-label', text);
    el.textContent = '';
    Array.from(text).forEach(function (ch, i) {
      var span = document.createElement('span');
      span.setAttribute('aria-hidden', 'true');
      span.textContent = ch;
      span.style.setProperty('--i', String(i));
      el.appendChild(span);
    });
    el.classList.add('amyan-shine');
  }

  function init() {
    SELECTORS.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(splitIntoLetters);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();